import React from "react";
import styled from "styled-components";
import { Column, Text, Title } from "../../../theme/index";
import deskImg from "../../../../assets/desk.png";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5em 0;
  @media (max-width: 1100px) {
    flex-direction: column;
  }
`;

const Image = styled.img`
  width: 80%;
`;

const StyledColumn = styled(Column)`
  width: 40%;
  margin: 0 0 0 2em;
  @media (max-width: 780px) {
    width: 95%;
    align-items: center;
    margin: 0 auto;
    text-align: center;
  }
`;

const StyledImageColumn = styled(Column)`
  width: 50%;
  align-items: flex-end;
  margin: 0 1em 0 0;
  @media (max-width: 780px) {
    width: 100%;
    margin: 0;
    align-items: center;
  }
`;

const StyledText = styled(Text)`
  text-align: left;
  color: #2b2b2b;
  @media (max-width: 780px) {
    text-align: center;
  }
`;

export default function Content() {
  return (
    <Wrapper>
      <StyledColumn>
        <Title orange>
          Continuing education has been described as the Wild West
        </Title>
        <StyledText>
          With CE requirements varying widely across professions and
          jursidictions. So many variables within rules and regulations leads to
          greater difficulty for licensed professionals to navigate renewal
          compliance. At AchieveCE, we pride ourselves in providing a platform
          that streamlines the CE process. It is our unwavering goal for each of
          our students to have the confidence that their CE requirements will be
          efficiently and accurately fulfilled.
        </StyledText>
      </StyledColumn>
      <StyledImageColumn>
        <Image src={deskImg} />
      </StyledImageColumn>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/screens/About/components/Content.jsx